import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function normalizeAxiosError(e) {
    return e?.response?.data?.error || e?.message || "Unbekannter Fehler";
}

export default function useDeliveryServices() {
    const [deliveryServices, setDeliveryServices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchDeliveryServices = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/delivery-services`, { withCredentials: true });
            const data = res.data?.delivery_services ?? res.data ?? [];
            setDeliveryServices(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(normalizeAxiosError(e));
        } finally {
            setLoading(false);
        }
    }, []);

    const createDeliveryService = useCallback(async (payload) => {
        try {
            const res = await axios.post(`${API_BASE}/api/delivery-services`, payload, { withCredentials: true });
            await fetchDeliveryServices();
            return res.data?.delivery_service;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchDeliveryServices]);

    const updateDeliveryService = useCallback(async (id, payload) => {
        try {
            const res = await axios.put(`${API_BASE}/api/delivery-services/${id}`, payload, { withCredentials: true });
            await fetchDeliveryServices();
            return res.data?.delivery_service;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchDeliveryServices]);

    const deleteDeliveryService = useCallback(async (id) => {
        try {
            await axios.delete(`${API_BASE}/api/delivery-services/${id}`, { withCredentials: true });
            await fetchDeliveryServices();
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchDeliveryServices]);

    useEffect(() => {
        fetchDeliveryServices();
    }, [fetchDeliveryServices]);

    return {
        deliveryServices,
        loading,
        error,
        fetchDeliveryServices,
        createDeliveryService,
        updateDeliveryService,
        deleteDeliveryService,
    };
}
